import { handleAmount } from './index'
import _ from 'lodash'

export const images = {
  choose: require('images/choose.png'),
  balance: require('images/balance.png'),
  bankcard: require('images/bankcard.png'),
  visa: require('images/visa.png'),
  mastercard: require('images/mastercard.png'),
  messagePay: require('images/messagePay.png'),
}

export const cardType = {
  DC: 'Debit Card',
  CC: 'Credit Card',
  GC: 'Card',
  DEBIT: 'Debit Card',
  CREDIT: 'Credit Card',
  OTHER: 'Card',
  undefined: 'Card',
}

export function handlePayMethod(payMethod) {
  var name, thumb
  if (!_.isPlainObject(payMethod)) {
    return {}
  }
  switch (payMethod.type) {
    case 'session_pay':
      name = 'Bank card'
      thumb = images.bankcard
      break
    case 'balance':
      name = `Balance(${handleAmount({
        currency: payMethod.accountCurrency,
        amount: payMethod.availableBalance,
      })})`
      thumb = images.balance
      break
    case 'card_pay':
      name = `${cardType[payMethod.cardType]}(${payMethod.cardNo})`
      thumb = images[payMethod.cardOrg.replace(/ /g, '').toLocaleLowerCase()]
      break
    case 'message_pay':
      name = 'Message Pay'
      thumb = images.messagePay
      break
    default:
      break
  }
  return {
    ...payMethod,
    name,
    thumb,
  }
}

export const downloadAppUris = {
  iOS: {
    PayBy: 'https://apps.apple.com/ae/app/payby/id1513907527',
    BOTIM: 'https://botim.me/home/',
    ToTok: 'https://totok.ai/',
  },
  Android: {
    PayBy: 'https://www.payby.com/android-download',
    BOTIM: 'https://botim.me/home/',
    ToTok: 'https://totok.ai/',
  },
}
